export const findExpandedSku = (
  sku: { materialId?: string; skuId: string }[],
  materials: any[],
) => {
  let skuList: string[] = [];

  materials.forEach(m => {
    skuList = [
      ...skuList,
      ...m.allSpuList.filter(s => s.status === 'ONLINE').map(s => s.id),
    ];
  });
  let expandedSku = [];
  for (const s of sku) {
    if (!skuList.includes(s.skuId)) {
      const material = s.materialId
        ? materials.find(m => m.id === s.materialId)
        : materials.find(m => m.allSpuList.some(spu => spu.id === s.skuId));
      const newSkuId = material?.allSpuList.find(s => s.status === 'ONLINE')
        ?.id;

      if (newSkuId) {
        expandedSku.push({
          oldSkuId: s.skuId,
          newSkuId: newSkuId,
          materialId: material?.id,
        });
      }
    }
  }

  return expandedSku;
};
